import { Injectable } from '@angular/core';

declare let gtag: Function;
declare let fbq: Function;

/**
 * Thin product-analytics wrapper. Fans events out to the app's existing sinks
 * (Google Analytics `gtag` + Facebook Pixel `fbq`); each call is a no-op when
 * the corresponding global isn't present, so it's safe in every environment.
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    track(event: string, params: Record<string, unknown> = {}): void {
        try {
            if (typeof gtag !== 'undefined') {
                gtag('event', event, params);
            }
        } catch {
            /* never let analytics break the UX */
        }
        try {
            if (typeof fbq !== 'undefined') {
                fbq('trackCustom', event, params);
            }
        } catch {
            /* no-op */
        }
    }
}
